export const BPM_POLLING_INTERVAL           = 800 // in ms
export const AUDIO_RECORD_LIMIT             = 600 // in seconds
export const DOCUMENT_TYPE_CAR_PICTURE      = 1
export const DOCUMENT_TYPE_CAR_REGDOC       = 2
export const DOCUMENT_TYPE_PART_PICTURE     = 3
export const DOCUMENT_TYPE_USER_AVATAR      = 4
export const DOCUMENT_TYPE_FEEDBACK_AUDIO   = 5
export const DOCUMENT_TYPE_PART_CLIST       = 6
export const DOCUMENT_TYPE_PART_STICKER     = 7